import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { TransactionType } from '@frontend/transaction/types';
import React from 'react';

const ID = 'transaction-type-select';
export const TransactionTypeSelectV2 = (props: Omit<SelectInputV2Props<string>, 'options'>) => {
    return (
        <SelectInputV2
            {...props}
            id={props.id || ID}
            options={Object.values(TransactionType).map((c) => ({ label: c, value: c }))}
            label={props.label || 'Transaction type'}
        />
    );
};
